import { Route, Routes } from "react-router-dom";
import ParentLayout from "./pages/ParentLayout/ParentLayout";
import { AboutPage } from "./pages/AboutPage/AboutPage";
import { CardsListPage } from "./pages/CardsListPage/CardsListPage";
// import { SpreadPage } from "./pages/SpreadsPage/SpreadPage";
import { path } from "./api/data/consts";
import { SpreadsCatalogPage } from "./pages/SpreadsPage/SpreadsCatalogPage";
import { SpreadPage } from "./pages/SpreadPage/SpreadPage";

function App() {
  return (
    <Routes>
      <Route
        path={path.startPage}
        element={<ParentLayout child={<AboutPage />} />}
      />
      <Route
        path={path.cardListPage}
        element={<ParentLayout child={<CardsListPage />} />}
      />
      <Route
        path={path.spreadsPage}
        element={<ParentLayout child={<SpreadsCatalogPage />} />}
      />
      <Route
        path={`${path.spreadsPage}/:spreadId`}
        element={<ParentLayout child={<SpreadPage />} />}
      />
    </Routes>
  );
}

export default App;
